// extracted by mini-css-extract-plugin
module.exports = {"slider_container":"Facts2_slider_container__1SO2m","wrapper":"Facts2_wrapper__36I8q","card":"Facts2_card__1IUqs","icon":"Facts2_icon__1sX8K","header":"Facts2_header__2MrRK"};